import { useEffect, useState } from "react";
import styles from "./Tabs.module.css";

/** tabs: [{ key, label, badge?, content }] */
export function Tabs({ tabs, defaultKey, onChange }) {
  const [active, setActive] = useState(defaultKey || tabs[0]?.key);

  /* FOLLOW THE ROUTE. A link from inside one tab to another (Upgrade on a
     locked theme -> Subscription) changes the URL while this component
     stays mounted, and the initial state alone ignored it: the address
     changed and nothing else did. */
  useEffect(() => {
    if (defaultKey) setActive(defaultKey);
  }, [defaultKey]);

  function select(key) {
    setActive(key);
    onChange?.(key);
  }

  const activeTab = tabs.find((t) => t.key === active) || tabs[0];

  return (
    <div>
      <div className={styles.tablist} role="tablist">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            role="tab"
            aria-selected={tab.key === active}
            className={[styles.tab, tab.key === active ? styles.active : ""].join(" ")}
            onClick={() => select(tab.key)}
          >
            {tab.label}
            {tab.badge && <span className={styles.badge}>{tab.badge}</span>}
          </button>
        ))}
      </div>
      <div role="tabpanel" className={styles.panel}>
        {activeTab?.content}
      </div>
    </div>
  );
}
